import React from 'react'

export default function FormTemplatesIcon() {
  return (
    <svg width="35px" height="35px" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
      <rect x="7" y="5" width="32" height="36" rx="3" stroke="currentColor" strokeWidth="2" fill="none"/>
      <line x1="13" y1="14" x2="33" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="13" y1="20" x2="33" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="13" y1="26" x2="26" y2="26" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="13" cy="33" r="2" fill="currentColor"/>
      <circle cx="21" cy="33" r="2" fill="currentColor"/>
      <circle cx="29" cy="33" r="2" fill="currentColor"/>
    </svg>
  )
}
